Raven = require('raven-js');

define ["scriptjs"], ($script) ->
  ($http, $q, $localStorage, $rootScope, $timeout, $state, $resource, $cacheFactory, Landlord, User, ApplicationTemplate, RENTAPPLICATION_API_URL) ->
    rentappService =
      isLoggedIn: () -> rentappService.isAuthenticated
      register: (username, password1, extra) ->
        register_data =
          username: username
          password1: password1
          password2: password1
        angular.extend(register_data, extra)

        $http.post "#{RENTAPPLICATION_API_URL}/api/v1/user/register/",
          register_data
      login: (username, password) ->
        $cacheFactory.get("$http").removeAll()
        $http.post "#{RENTAPPLICATION_API_URL}/api/v1/user/login/",
          username: username
          password: password
        .then (response)->
          rentappService.isAuthenticated = true
          response.data
      getMe: () ->
        $rootScope.loading_user = true
        User.getMe().$promise.then (user) ->
          $rootScope.user = user
          Raven.setUserContext({username: user.username})
          user
        .finally ->
          $rootScope.loading_user = false
      getStripe: ->
        deferred = $q.defer()
        
        if $rootScope.stripe
          deferred.resolve($rootScope.stripe)
        else
          $script "https://js.stripe.com/v3/", ->
            stripe = Stripe(ENV.STRIPE_PUBLISHABLE_KEY)
            $rootScope.stripe = stripe
            deferred.resolve stripe
        deferred.promise
      logout: (username, password) ->
        $cacheFactory.get('$http').removeAll()
        Raven.setUserContext()
        rentappService.isAuthenticated = false
        $localStorage.$reset()
        $rootScope.user = undefined
        $http.get "#{RENTAPPLICATION_API_URL}/api/v1/user/logout/"
      getAccounts: (params) ->
        $http
          url: "#{RENTAPPLICATION_API_URL}/api/v1/account/?balance__gt=0"
          params: params
          cache: false
      getTransactions: (params) ->
        $http
          url: "#{RENTAPPLICATION_API_URL}/api/v1/transaction/?limit=10&offset=0"
          params: params
          cache: false
      enableClassic: () ->
        $http.patch "#{RENTAPPLICATION_API_URL}/api/v1/landlord/me/",
          'edge_enabled': false

    window.DEBUG_rentappService = rentappService

    rentappService



// WEBPACK FOOTER //
// ./services/RentappService.coffee